module.exports = __webpack_public_path__ + "img/list_Character_sq_09.7250c1cd.jpeg";